import { c as _c } from "react/compiler-runtime";
import type { ElementType } from 'react';
import MUICard, { CardProps, CardTypeMap } from '@mui/material/Card';
export type { CardProps };
const Card = t0 => {
  const $ = _c(12);
  let children;
  let otherProps;
  let sx;
  let t1;
  if ($[0] !== t0) {
    ({
      children,
      variant: t1,
      sx,
      ...otherProps
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = otherProps;
    $[3] = sx;
    $[4] = t1;
  } else {
    children = $[1];
    otherProps = $[2];
    sx = $[3];
    t1 = $[4];
  }
  const variant = t1 === undefined ? "outlined" : t1;
  let t2;
  if ($[5] !== sx) {
    t2 = {
      borderColor: "layout.surface.border",
      ...sx
    };
    $[5] = sx;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== children || $[8] !== otherProps || $[9] !== t2 || $[10] !== variant) {
    t3 = <MUICard sx={t2} variant={variant} {...otherProps}>{children}</MUICard>;
    $[7] = children;
    $[8] = otherProps;
    $[9] = t2;
    $[10] = variant;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  return t3;
};
export default Card;